import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';



import { ApmTranslatePipe, AuthFacade, ResourcesService, UserPermission } from '@mitsubishi/core';
import { DatasheetFacade } from '@mitsubishi/project/data-access';
import { ListTileComponent, ResourceImageDirective, SectionTitleComponent } from '@mitsubishi/shared/ui';



import { FieldWrapper, FormlyField, FormlyFieldConfig } from '@ngx-formly/core';















@Component({
  selector: 'apm-list-wrapper',
  templateUrl: './list-wrapper.component.html',
  styleUrls: ['./list-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    NgClass,
    ResourceImageDirective,
    FormlyField,
    SectionTitleComponent,
    MatTooltip,
    ApmTranslatePipe,
    ListTileComponent,
  ],
})
export class ListWrapperComponent extends FieldWrapper implements OnInit {
  readonly #resourcesService = inject(ResourcesService);
  readonly #datasheetFacade = inject(DatasheetFacade);

  canDebug = inject(AuthFacade).canDebug;
  hasDatasheetMoreDetailsPermission = inject(AuthFacade).hasPermission(UserPermission.DatasheetMoreDetails);

  selectedRow$ = this.#datasheetFacade.selectedRow$;
  isEditing$ = this.#datasheetFacade.isEditing$;

  isFirst = false;
  areAllFieldsHidden = false;

  ngOnInit() {
    this.isFirst = this.field?.parent?.fieldGroup?.findIndex(f => f.key === this.field.key) === 0;
    this.areAllFieldsHidden = this.field.fieldGroup
      ? this.field.fieldGroup.every(field => field.props?.hidden === true)
      : true;
  }

  setSelectedRow(key?: any) {
    this.#datasheetFacade.setSelectedRow(key);
  }

  getRowLabel(field_props: FormlyFieldConfig['props']): string {
    return this.#resourcesService.getTextResourceWithPrefixSuffix({
      resourceId: field_props?.label,
      prefixResourceId: field_props?.prefixResourceId,
      suffixResourceId: field_props?.suffixResourceId,
    });
  }
}
